import React from 'react';
import { EMPTY_FN, TenantConf } from '@libs/shared';

interface CorpProfileProps {
    profile?: TenantConf;
    onUpdateProfile: (profile: Partial<TenantConf>) => void;
}

const CorpProfileContext = React.createContext<CorpProfileProps>({
    onUpdateProfile: EMPTY_FN
});
CorpProfileContext.displayName = 'CorpProfileContext';

export default CorpProfileContext;
